<template lang="html">
  <div class="form-control"
    :class="[classes, {'is-read-only': readOnly, 'is-error': errors.length}]">
    <div class="field-wrapper">
      <label class="label" :for="name" v-if="label">
        {{ label }}
      </label>
      <Tooltip
        v-if="tooltip"
        :tooltipText="tooltip"/>
      <span class="is-optional" v-if="optional"> {{ $t('components.input.optional') }}</span>
      <div class="form-select">
        <div class="form-wrapper">
          <select class="form-field"
            :value="value"
            @input="$emit('input', $event.target.value)"
            @change="$emit('change', $event.target.value)"
            :name="name"
            :id="name"
            :disabled="readOnly">
            <option v-if="placeholder" value="" disabled selected>{{placeholder}}</option>
            <option v-for="(option, index) in options"
              :key="option[optionValueAttr]"
              :value="option[optionValueAttr]">
              {{ option[optionLabelAttr] }}
            </option>
          </select>
          <span class="error-information" v-for="(error, index) in errors" :key="index">
            {{ error }}
          </span>

        </div>
      </div>
    </div>
  </div>

</template>

<script lang="js">
import Tooltip from '@/components/Tooltip.vue';

export default {
  name: 'VqSelect',
  components: {
    Tooltip,
  },
  props: {
    classes: String,
    label: String,
    placeholder: {
      type: String,
      required: false
    },
    value: [String, Number],
    name: String,
    optionValueAttr: {
      type: [String, Number],
      default: 'value',
    },
    optionLabelAttr: {
      type: [String, Number],
      default: 'label',
    },
    options: Array,
    optional: {
      type: Boolean,
      default: false,
    },
    tooltip: String,
    readOnly: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default() { return []; },
    },
  },

  created() {
  }
};
</script>

<style scoped lang="scss">
</style>
